import React, { memo } from "react";

function PlaceholderImagenMitico({
  logoNegocio = "/logo-mitico.png",
  texto = "Imagen próximamente",
  height = "95px",
  borderRadius = "12px",
}) {
  return (
    <div
      style={{
        width: "100%",
        height,
        borderRadius,
        background: "linear-gradient(135deg, #fff7ec 0%, #f0ddc5 100%)",
        border: "1px solid #f0dfc9",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        padding: "8px",
        textAlign: "center",
        marginBottom: "8px",
      }}
    >
      <img
        src={logoNegocio}
        alt="Mítico"
        style={{
          maxWidth: "70px",
          maxHeight: "38px",
          objectFit: "contain",
          marginBottom: "5px",
        }}
      />

      <span
        style={{
          fontSize: "10px",
          fontWeight: "900",
          color: "#9a5c1f",
          lineHeight: "1.1",
        }}
      >
        {texto}
      </span>
    </div>
  );
}

export default memo(PlaceholderImagenMitico);
